import type { AcuityHistoryResponse, UUID } from "@/core/types";
import { acuityRequestsTyped } from "@/api/(requests)/acuityTyped";

export async function getAcuityHistory(patientId: UUID): Promise<AcuityHistoryResponse> {
  return acuityRequestsTyped.get_acuity_history({ context: { showLoader: false }, patientId });
}
